// extracted by mini-css-extract-plugin
export default {"container":"Centered_container__WByzL"};